<nx-card class="table-card-viewer">
  <page-list-view-header
    [newSupplier]="new()"
    [title]="headerTitle"
    [(viewChangers)]="viewChangers"
    [menuWantedInMobileView]="true"
    [onlyAddNewButtonWantedInMobileView]="false"
  ></page-list-view-header>

  @if (viewChangers['mapView'].show && mapModels) {
    <app-map height="calc(100vh - 152px)" [models]="mapModels" [startZoom]="6" [markerClickSupplier]="markerClick()"
    [showYourPosition]="false" [countryCodes]="countryCodesInAddress"></app-map>
  }
  @if (viewChangers['tableView'].show) {
    <div class="aquila-table-custom">
      <aquila-table [rows]="models" [colDefinitions]="colDef" [actionConfig]="actionDef"
        [elementsPerPage]="pageSize"
      [showAsList]="mobile"></aquila-table>
    </div>
  }
</nx-card>

<ng-template #test let-value="value">
  @for (role of value; track role) {
    {{ role }},
  }
</ng-template>
